import moment from 'moment';
import '../../CSS/Table.css';
import { Spin, Tag } from 'antd';
import { connect } from 'react-redux';
import { config } from '../../constant';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { BellFilled } from '@ant-design/icons';
import StyledTable from "../../../../../commons/styles/table";
import { notificationtableMock } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { tableTranslation } from '../../../Utils/Adapter/translationAdapter';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const NotificationTable = (props) => {

  const [columns, setColumns] = useState([]);
  const [tabledata, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [raisedEvents, setRaisedEvents] = useState(0);
  const [closedEvents, setClosedEvents] = useState(0);
  const [dataSource, setDataSource] = useState([]);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const requestCheck = useRef(true);
  let timeTicket = useRef(null);
  let abortController = useRef(new window.AbortController());


  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);


  const updateData = async (data) => {
    try {
      // this.columns = [];
      // this.tabledata = [];
      const columnNames = Object.keys(data[0]);

      columnNames.map((value) => {
        //   if (value === "tagname") {
        if (value.length > 0 && value !== 'color' && value !== 'noData') {
          columns.push({
            title: value,
            dataIndex: value,
            key: value,
            render(text, record) {
              return {
                props: {
                  //style: { background: Math.abs(key % 2) === 1 ? '#1a1a1a' : '#000' },
                  style: { color: record && record.color ? record.color : '#000' }
                },
                children: (
                  <text style={{ color: record && record.color ? record.color : '#8c8c8c' }}>
                    {text}
                  </text>
                )
              };
            }
          });
        }
        //  } else if (value === "tagvalue") {
        //  this.columns.push({
        //   title: "Tag Value",
        //   dataIndex: value,
        //  key: value,
        //   render: text => <text style={{ color: "orange" }}>{text}</text>
        //  });
        // }
        return {};
      });

      if (data && data[0] && data[0]['noData']) {
        return {};
      } else {
        data.map((dataval, dataindex) => {
          dataval.key = dataindex + 1;
          tabledata.push(dataval);
          return {};
        });
      }

      let translationTable = await tableTranslation(columns, props.translationCache);
      setColumns(translationTable);
      setTableData(tabledata);
      // }, 3000);
    } catch (e) {
      setColumns([]);
      setTableData([]);
    }
  };

  const getData = async () => {
    let json = [];
    requestCheck.current = false;
    let { graphprops } = props;
    setErrorInAPI(false);
    setNoDataInDB(false);
    setLoading(true);
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = notificationtableMock;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      let queryData = json && json.query ? json.query : [];

      if (queryData && Array.isArray(queryData) && queryData[0] && queryData[1]) {
        setRaisedEvents(queryData[0] && queryData[0].Value ? queryData[0].Value : '');
        setClosedEvents(queryData[1] && queryData[1].Value ? queryData[1].Value : '');
      }
      let dataSource = json && json.query1 ? json.query1 : [];
      setDataSource(dataSource);
      setRefreshDateTime(moment());
      updateData(dataSource);
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };
  const filteringEvents = (events, tagName) => {

    let tabledata = [];
    if (events === 'raisedEvents') {
      tabledata = dataSource.filter(function (item) {
        return item.Status === tagName;
      });
    } else if (events === 'closedEvents') {
      tabledata = dataSource.filter(function (item) {
        return item.Status === tagName;
      });
    }
    setTableData(tabledata);
  };


  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}{' '}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <span>
          {columns && columns.length > 0 ? (
            <div>
              <div className="notificationMain">
                <div
                  className="notificationDiv"
                  onClick={() =>
                    filteringEvents(
                      'raisedEvents',
                      props.graphprops[props.graphprops.graph].activateLights
                    )
                  }
                >
                  <BellFilled
                    style={{
                      marginRight: '20px',
                      fontWeight: '800',
                      fontSize: '2.5em',
                      color: props.graphprops.iconColor
                        ? props.graphprops.iconColor
                        : '#389e0d'
                    }}
                  />
                  <span
                    style={{
                      color: props.graphprops.iconColor
                        ? props.graphprops.iconColor
                        : 'green'
                    }}
                  >
                    {raisedEvents}
                  </span>
                </div>

                <div
                  className="notificationDiv1"
                  onClick={() =>
                    filteringEvents(
                      'closedEvents',
                      props.graphprops[props.graphprops.graph].deActivateLights
                    )
                  }
                >
                  <BellFilled
                    style={{
                      marginRight: '20px',
                      fontWeight: '800',
                      fontSize: '2.5em',
                      color: props.graphprops.titleColor
                        ? props.graphprops.titleColor
                        : 'red'
                    }}
                  />
                  <span
                    style={{
                      color: props.graphprops.titleColor
                        ? props.graphprops.titleColor
                        : 'red'
                    }}
                  >
                    {closedEvents}
                  </span>
                </div>
              </div>
              <div>
                <StyledTable size="small"
                  scroll={{ x: tabledata.length > 5 ? true : false }}
                  style={{ padding: '0px 10px', fontSize: '13px !important' }}
                  columns={columns}
                  dataSource={tabledata}
                  pagination={{ pageSize: '5' }}
                />
              </div>
            </div>
          ) : (
           <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              <Spin spinning={loading} tip="Loading..." />
            </div>
          )}
        </span>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};
export default connect(mapStateToProps)(NotificationTable);
